import { useContext, useEffect, useState } from 'react';
import { QuickInfoItem } from './QuickInfoItem';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';
import QuickInfoFallback from './QuickInfoFallback';
import { General, QuickInfo } from '~js/React/ObjectPageEnums';

const QuickInfoFarm = () => {
  const { estate: data } = useContext(ObjectPageContext);
  const [houseNumber, setHouseNumber] = useState<number>();
  const [alignment, setAlignment] = useState<string>('');
  const [areaText, setAreaText] = useState<string>('');
  const [areaValue, setAreaValue] = useState<string>('');
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    setIsLoaded(false);
    if (
      data?.mainResidentialBuilding != null &&
      data?.otherResidentialBuildings?.length
    ) {
      setHouseNumber(1 + data?.otherResidentialBuildings?.length);
    }

    if (
      data?.mainResidentialBuilding?.livingSpace &&
      data?.mainResidentialBuilding?.otherSpace
    ) {
      setAreaText(QuickInfo.LivingAndOtherArea);
      setAreaValue(
        data?.mainResidentialBuilding?.livingSpace
          .toString()
          .replace('.', ',') +
          ' + ' +
          data?.mainResidentialBuilding?.otherSpace.toString().replace('.', ',')
      );
    } else if (data?.mainResidentialBuilding?.livingSpace) {
      setAreaText(QuickInfo.LivingSpace);
      setAreaValue(
        data?.mainResidentialBuilding?.livingSpace.toString().replace('.', ',')
      );
    } else if (data?.mainResidentialBuilding?.otherSpace) {
      setAreaText(QuickInfo.OtherArea);
      setAreaValue(
        data?.mainResidentialBuilding?.otherSpace.toString().replace('.', ',')
      );
    }
  }, [data?.mainResidentialBuilding, data?.otherResidentialBuildings]);

  useEffect(() => {
    if (data?.alignment?.length) {
      let alignmentItems = '';
      for (var i = 0; i < data?.alignment?.length; i++) {
        if (alignmentItems.length) {
          alignmentItems += ', ' + data?.alignment[i];
        } else {
          alignmentItems = data?.alignment[i];
        }
      }
      setAlignment(alignmentItems);
    }
    setIsLoaded(true);
  }, [data?.alignment]);

  if (!isLoaded) {
    return <QuickInfoFallback />;
  }
  return (
    <div className="flex flex-wrap lg:flex-row lg:flex-auto mt-4 lg:mt-6 px-3 lg:px-7 xxl:px-4 quickInfo font-ic max-w-7xl mx-auto">
      {areaText != '' && (
        <QuickInfoItem
          headline={areaText}
          comment={data?.buildingInfo?.areaSourceComment}
          value={areaValue + ' m²'}
          iconUrl={'/Images/Icons/objectPage/livingArea.svg'}
        />
      )}

      {houseNumber && (
        <QuickInfoItem
          headline={QuickInfo.BuildingNo}
          value={houseNumber.toString() + ' st'}
          iconUrl={'/Images/Icons/objectPage/buildings.svg'}
        />
      )}
      {data?.propertyArea && (
        <QuickInfoItem
          headline={QuickInfo.TotalArea}
          value={data?.propertyArea.toString().replace('.', ',') + ' ha'}
          iconUrl={'/Images/Icons/objectPage/totalArea.svg'}
        />
      )}

      {data?.buildingInfo?.buildingYear && (
        <QuickInfoItem
          headline={QuickInfo.BuildingYear}
          value={data?.buildingInfo?.buildingYear}
          comment={data?.buildingInfo?.commentaryForBuildingYear}
          iconUrl={'/Images/Icons/objectPage/buildingYear.svg'}
        />
      )}
      {data?.mainResidentialBuilding?.buildingType && (
        <QuickInfoItem
          headline={QuickInfo.Type}
          value={data?.mainResidentialBuilding?.buildingType}
          iconUrl={'/Images/Icons/objectPage/type.svg'}
        />
      )}
      {alignment && (
        <QuickInfoItem
          headline={QuickInfo.Alignment}
          value={alignment}
          iconUrl={'/Images/Icons/objectPage/inriktning.svg'}
        />
      )}
      {data?.buildingInfo?.propertyUnitDesignation && (
        <QuickInfoItem
          headline={QuickInfo.PropertyUnitDesignation}
          value={data?.buildingInfo?.propertyUnitDesignation}
          iconUrl={'/Images/Icons/objectPage/fastighetsbeteckning.svg'}
        />
      )}
      {data?.dates?.possibleAccessDate && (
        <QuickInfoItem
          headline={General.AccessDate}
          value={data?.dates?.possibleAccessDate}
          iconUrl={'/Images/Icons/objectPage/access.svg'}
        />
      )}
    </div>
  );
};
export default QuickInfoFarm;
